export const ProxyList = {
    list:
    `103.241.199.3:49152:user49152:pwafXf7CrZ
    103.241.199.2:49200:user49200:mzepB66GdV
    103.241.199.15:49137:user49137:lcjyXqa3tn
    103.15.89.245:49156:user49156:bHv0PXFWHU
    103.241.199.17:49212:user49212:7hCB5xcibV
    103.187.168.98:49120:user49120:baSiL8aBBU
    103.241.199.21:49044:user49044:yP5mPhAe4X
    103.15.89.215:49305:user49305:aCrB1S6bJo
    103.121.90.181:49166:user49166:FY30gpXgQq
    103.187.168.97:49027:user49027:KKq0Qeug1C
    103.15.89.238:49141:user49141:LsHjLwt7z9
    103.241.199.11:49481:user49481:ao9FGkr4QY
    103.241.199.14:49037:user49037:rddDitWOq3
    103.241.199.21:49100:user49100:KmKbrTcQoP
    103.187.168.98:49199:user49199:SvffPPzLm0
    103.187.168.98:49090:user49090:QDt2G57BPY
    103.15.89.241:49492:user49492:sEfUdMuVGo
    103.241.199.19:49292:user49292:yARBbgbo4Y
    103.162.31.11:49317:user49317:zYrTmLJ6D1
    103.79.141.134:49027:user49027:u7e9qFOdSa
    103.187.168.128:49092:user49092:4JFjChz9Px
    103.187.168.128:49197:user49197:7b9SCeCt55
    103.241.199.8:49313:user49313:Q6PwfvZyZr
    103.79.141.70:49119:user49119:96vCANAR3k
    103.162.31.66:49467:user49467:66CBWE73aU
    103.162.30.94:49135:user49135:qRNv3IA3n4
    103.79.141.134:49010:user49010:2hAx17dERg
    103.187.168.129:49187:user49187:Z5r5n1AoFr
    103.15.89.242:49059:user49059:Aiq8T2pRHk
    103.241.199.15:49274:user49274:RTSL2OQRaj
    103.162.31.61:49102:user49102:PQBF1TccBH
    103.187.168.16:49006:user49006:uskvhwRgIa
    103.187.168.116:49158:user49158:FYnIAdfWnK
    103.121.89.112:49119:user49119:nNOBRimuM4
    103.79.142.142:49013:user49013:U5yt2EnJeK
    103.121.89.235:49029:user49029:9ZbF55JV8H
    103.162.31.34:49417:user49417:KqBm7bmGi4
    103.187.168.116:49001:user49001:SjfhIZ5Dr4
    103.161.16.168:49065:user49065:TbNXslrUEp
    103.79.141.66:49196:user49196:7YSvBrVKa1
    103.15.89.241:49214:user49214:XyNom0RlpO
    103.79.143.230:49107:user49107:KgIcOE896N
    103.241.199.12:49044:user49044:8KzO7UZ5S0
    103.241.199.8:49414:user49414:Qc4FTU3Lqk
    103.241.199.17:49052:user49052:4Ut905yRYS
    103.15.89.235:49483:user49483:5bkGQlWKRg
    103.79.141.34:49146:user49146:h2Jug5Y4S7
    103.15.89.242:49337:user49337:9Pklpn3ERN
    103.15.89.241:49345:user49345:ED3qoZxhtH
    103.15.89.202:49091:user49091:X4VhrKWKFH
    103.15.89.243:49297:user49297:50HGchkbBY
    103.241.199.18:49341:user49341:twG5rUJXDH
    103.79.141.28:49027:user49027:dcY0StdAMq
    103.241.199.16:49282:user49282:RWaR9ngpxd
    103.121.91.219:49158:user49158:86r2mfWS8W
    103.161.17.111:49134:user49134:uF9BwniVBm
    45.124.84.110:49005:user49005:Iq4DUfs9uZ
    103.162.31.69:49376:user49376:K8ZGQZFnug
    103.187.168.126:49112:user49112:Q6MrVNaDO4
    103.162.31.78:49145:user49145:7x3KImelKX
    103.15.89.234:49362:user49362:RsbWaHeXYQ
    103.241.199.15:49354:user49354:3LmDiZm3jF
    103.241.199.15:49335:user49335:vjuHiodC60
    103.187.168.101:49043:user49043:UyWkibM8Oa
    103.79.142.144:49106:user49106:t6GNIIS39q
    103.241.199.11:49383:user49383:M80Hxqb6F4
    103.187.168.116:49183:user49183:EpPmzARlY9
    103.241.199.10:49105:user49105:hjBCPLzecQ
    103.241.199.19:49375:user49375:7rYxfNWnjp
    103.121.89.112:49070:user49070:7h0t3QOAKR
    103.241.199.8:49228:user49228:FlfuDqaTEN
    103.187.168.100:49187:user49187:axCYKoVd6w
    103.162.30.90:49096:user49096:rFnXhX6wIB
    103.241.199.5:49366:user49366:kusWN6lvNs
    103.162.30.96:49081:user49081:3UMGceEgXs
    103.162.31.61:49072:user49072:0ZqLRsxXgE
    103.241.199.12:49051:user49051:vWczD9RT8U
    103.187.168.126:49175:user49175:lXhiDlOSGm
    103.121.89.235:49159:user49159:HoTcy8fpat
    103.241.199.19:49290:user49290:cLIkNyj50f
    103.79.141.52:49002:user49002:PWclx6prgn
    103.241.199.15:49115:user49115:OrnVk1MGNJ
    103.241.199.3:49354:user49354:3F9p5045Xs
    103.162.31.69:49168:user49168:YFjw24Dmzm
    103.15.89.239:49453:user49453:AiO4asLyCC
    103.162.31.14:49037:user49037:Jrkcmm87wL
    103.187.168.129:49003:user49003:gUSFD43KYf
    103.121.91.66:49159:user49159:P8UPUDY1wq
    103.187.168.16:49071:user49071:ZoSrRNo2iJ
    103.15.89.236:49118:user49118:8l1xeIc9YB
    103.187.168.115:49138:user49138:IZvBaqubGV
    103.162.30.83:49127:user49127:NaLbkbVI62
    103.79.141.81:49105:user49105:QDlmgRMwri
    103.15.89.238:49209:user49209:Vgwyy7kpX9
    103.15.89.234:49197:user49197:myC6kWrBCW
    103.79.141.70:49023:user49023:bq4isOBQj0
    103.15.89.220:49103:user49103:7e8I39lOmZ
    103.15.89.205:49400:user49400:bvze5tCjNX
    103.121.91.217:49132:user49132:CY2W9pyY1p
    103.121.91.217:49026:user49026:rYD4EBW3HY
    103.121.91.219:49124:user49124:eOUmdoSwTk
    103.187.168.128:49046:user49046:OlN8iT8Fq9
    103.15.89.234:49322:user49322:7jgJv64Mp9
    103.187.168.97:49052:user49052:y4qraBItvk
    103.15.89.242:49312:user49312:wnH8FVImPJ
    103.15.89.216:49470:user49470:iN2tayROtk
    103.162.30.29:49139:user49139:mabBmugRxm
    103.121.90.181:49138:user49138:hlCXbYbERG
    103.79.141.18:49099:user49099:JLNeZYZoh7
    103.15.89.236:49066:user49066:Jl3SBSNqpp
    103.15.89.233:49249:user49249:Na5GTGwpid
    103.79.141.39:49159:user49159:uapCxdmhZO
    103.15.89.208:49493:user49493:Syrfn4QDk3
    103.15.89.205:49379:user49379:NgUW3LKHFm
    103.162.30.96:49183:user49183:ivwAZ7wRMy
    103.241.199.2:49496:user49496:KeW4hYv8mu
    103.187.168.16:49182:user49182:ZyNBjiGLfT
    103.241.199.21:49004:user49004:jYCXPMrmDI
    103.15.89.203:49376:user49376:qrZktFlPNu
    103.241.199.14:49187:user49187:YYuR9OEjN4
    103.241.199.5:49498:user49498:2jslcZdec0
    103.241.199.9:49133:user49133:cEH0CoWCUR
    103.79.141.134:49163:user49163:vu2LN6XPXe
    103.187.168.96:49086:user49086:7VQEbYinAi
    103.162.31.65:49470:user49470:a1KGl7QJZM
    103.15.89.243:49275:user49275:UDcygxrDNo
    103.15.89.205:49300:user49300:Y1H4fPderD
    103.241.199.17:49432:user49432:s77zTnZFD5
    103.15.89.243:49078:user49078:vUchoNJQ7n
    103.15.89.245:49160:user49160:sxM66CqrEB
    45.124.84.110:49117:user49117:fHgKfqan3L
    103.241.199.3:49088:user49088:wghjc896eg
    103.121.89.112:49112:user49112:hPE4h4fZCl
    103.241.199.6:49427:user49427:cbmNpB4di5
    103.15.89.202:49004:user49004:cdtNK67se2
    103.241.199.21:49463:user49463:i22cHm6qR8
    103.162.31.78:49101:user49101:JONo5qyvhh
    103.241.199.16:49251:user49251:JuhlVcr5OE
    103.15.89.234:49360:user49360:no1hj8NGip
    103.241.199.11:49243:user49243:Uczrd6Cqb9
    103.162.31.61:49398:user49398:8IatfQXR8s
    103.79.141.139:49059:user49059:GdGeYiV4j4
    103.15.89.240:49062:user49062:5XCgv2AmH9
    103.162.31.72:49281:user49281:HEfGMhDz0e
    103.187.169.14:49009:user49009:pIdgSVJ9js
    103.121.90.181:49085:user49085:nqL7uuDyGQ
    103.187.168.18:49020:user49020:xscxCNXA1j
    103.241.199.21:49183:user49183:IXfJtdlSfN
    103.241.199.2:49118:user49118:5ch03Z55VH
    103.162.31.14:49068:user49068:psC9Hr8RiU
    103.241.199.20:49265:user49265:HyMMoljoVj
    103.162.31.61:49309:user49309:FAFdP7N9Zh
    103.162.31.77:49140:user49140:3a454S5JE1
    103.15.89.216:49304:user49304:S6WAgGUEgQ
    103.241.199.12:49103:user49103:tAHUHkxjJo
    103.241.199.5:49468:user49468:rkgZNT0Bbt
    103.162.31.11:49142:user49142:7IsAp9s9Ty
    103.162.31.78:49041:user49041:yEgOZawm3P
    103.162.31.14:49091:user49091:XTmki6gmul
    103.15.89.235:49359:user49359:htc1tVDrfz
    103.162.31.76:49039:user49039:KQigCS8diS
    103.121.90.206:49104:user49104:DYACN00a2W
    103.162.31.14:49046:user49046:CJEFcMbq5x
    103.241.199.20:49364:user49364:RVeGMjMIYg
    103.162.30.78:49035:user49035:Bh7GWRTHlc
    103.162.31.14:49116:user49116:hLhXnAZepa
    103.241.199.11:49439:user49439:iLBpqvJvOP
    103.15.89.236:49201:user49201:vWzhbVSFx1
    103.162.31.11:49101:user49101:iEYGy8HZ7v
    103.121.90.181:49074:user49074:ryolQfFPSB
    103.3.244.158:49414:user49414:wBDnBdajoi
    103.241.199.6:49055:user49055:OedEhPG7m6
    103.162.31.77:49056:user49056:5RtsnnACjY
    103.162.31.78:49111:user49111:1GZ8JQVvWW
    103.121.90.206:49124:user49124:4gB5Ji8fNV
    103.162.31.14:49127:user49127:2yIwYMTyk1
    103.15.89.211:49470:user49470:re6QjvDIZp
    103.187.168.16:49100:user49100:1CfCRySxvL
    103.3.244.102:49349:user49349:vLIgOvZUoV
    103.241.199.9:49206:user49206:iDB27h0AGZ
    103.241.199.18:49347:user49347:ffBRZwBDUW
    103.241.199.16:49368:user49368:tn3MHQ2GDt
    103.15.89.245:49371:user49371:WvqeMWDvc6
    103.187.168.16:49095:user49095:hI3c4g3Vyf
    103.162.31.12:49218:user49218:3gVXQHRYkK
    103.241.199.6:49114:user49114:ylTN11YZQX
    103.162.31.77:49106:user49106:kcK1IYIS5c
    103.162.31.76:49116:user49116:PSjoS2HKpl
    103.162.31.14:49034:user49034:RhtC9AuAuC
    103.162.31.76:49099:user49099:BSIBKUu9m1
    103.162.31.14:49115:user49115:M2GLJJxcrG
    103.3.244.127:49302:user49302:68jzONzUET
    103.15.89.219:49319:user49319:zqjzjsF3Pa
    103.162.30.78:49173:user49173:C3roZN9pQy
    103.162.31.78:49075:user49075:SMJi1amrRf
    103.121.90.206:49162:user49162:nNOosLMBP9
    103.121.90.206:49012:user49012:BoaYtFoGVh
    103.15.89.245:49402:user49402:mdjM3hNmqL
    45.124.84.128:49317:user49317:4XOVsaopz6
    103.79.141.79:49032:user49032:itjASSP6CH
    103.187.169.10:49083:user49083:eAJa9mEriT
    103.3.244.158:49043:user49043:tDkyNufe3E
    103.121.90.206:49073:user49073:1PVYFCYEX8
    103.121.90.206:49185:user49185:3E4SFXAoc8
    103.15.89.205:49387:user49387:IXd6Zi0YsO
    103.15.89.238:49060:user49060:YkmwR2Ia9X
    103.241.199.9:49065:user49065:s26Y1dlPDN
    103.15.89.218:49032:user49032:VeXwRryOnc
    103.3.246.254:49020:user49020:N8EFJzIL2U
    103.121.90.237:49090:user49090:nMcKGPnsmk
    103.162.31.65:49070:user49070:yskVToI0BH
    103.15.89.235:49234:user49234:QmDE3Li8qE
    103.121.90.206:49066:user49066:VVltYtub6t
    103.162.31.76:49071:user49071:Uu3DptonqB
    103.15.89.236:49442:user49442:nry4bklDP2
    103.241.199.10:49150:user49150:dP67pv6dM4
    103.241.199.12:49011:user49011:u7OnqXNK5Y
    103.241.199.21:49366:user49366:x3jQmMbe9y
    103.162.31.72:49310:user49310:6or8pZEVUl
    103.79.141.139:49047:user49047:vPxzue2sYT
    103.15.89.212:49252:user49252:xNGNCeJ2gS
    103.241.199.19:49369:user49369:z5RAQktrfn
    103.187.169.13:49061:user49061:Fsw5IadzHf
    103.15.89.211:49283:user49283:cac7r3OHxz
    45.124.84.148:49340:user49340:uQVY3BNCuK
    103.241.199.14:49357:user49357:zXhWpcbTKO
    103.162.31.72:49088:user49088:vIYTF4NGtM
    103.162.31.72:49078:user49078:mqSYvEa7Rg
    103.162.31.12:49317:user49317:HvSF65Y0NK
    103.241.199.5:49264:user49264:f45Oe0pJ47
    103.162.31.65:49145:user49145:Pj68giOOCP
    103.162.31.77:49035:user49035:9WNplS0guq
    103.162.31.14:49161:user49161:622KE8YUMB
    103.241.199.2:49285:user49285:16q1d5SDzl
    103.15.89.202:49240:user49240:TqVdmo2k6p
    103.241.199.20:49442:user49442:yAAhcYaqHi
    103.162.31.11:49016:user49016:SLg8f8AisS
    103.241.199.12:49161:user49161:BPDQzJ0pq3
    103.121.90.181:49066:user49066:0oLH2upPb8
    103.79.141.24:49040:user49040:CJFW31lYgd
    103.79.141.46:49185:user49185:bwl7CU5tel
    103.241.199.19:49102:user49102:kctykuLgDY
    103.162.31.69:49372:user49372:aWTvWPBT55
    103.162.31.76:49060:user49060:efcmNmQFj8
    103.121.89.199:49196:user49196:OzMKpiMXAY
    103.3.246.218:49293:user49293:ekaGbVpNgg
    103.79.143.230:49127:user49127:NeuulkOTje
    103.15.89.208:49329:user49329:TDZTlTuBNn
    103.162.31.76:49075:user49075:ggYbqb1Eob
    103.121.90.206:49157:user49157:1QBFkRLDTO
    103.241.199.10:49365:user49365:IP2W5FQErk
    103.79.141.18:49193:user49193:DzTTbH9lpM
    103.121.90.206:49083:user49083:pDvBocs7IW
    103.162.31.77:49109:user49109:djTGHdBDxJ
    103.162.31.77:49013:user49013:AXq3EHOLx2
    103.121.90.237:49154:user49154:4LuDVk7SPN
    103.79.143.230:49011:user49011:bMo0Rxjdzo
    103.162.31.14:49143:user49143:6U89C3UMlL
    103.162.31.72:49174:user49174:8kEjN5BMKC
    103.15.89.201:49407:user49407:7eFIE3lJjt
    103.162.31.14:49160:user49160:iwxE5W69a3
    103.121.90.181:49005:user49005:5tOCcunQdN
    103.162.31.65:49051:user49051:Zg3yirBpzm
    103.162.31.11:49342:user49342:B8uGAJtdsH
    103.79.141.79:49033:user49033:72mM1YWrZm
    103.15.89.240:49289:user49289:LiE6ixeWMG
    103.241.199.14:49382:user49382:5PaFMvj3xH
    103.15.89.219:49260:user49260:Z6ybDxMEp0
    103.15.89.233:49407:user49407:WQCi9x0MUA
    103.121.90.206:49046:user49046:1AOYUVqoNj
    103.241.199.12:49013:user49013:unAk2xaDF2
    103.162.31.72:49232:user49232:G6x9XhbKyV
    103.15.89.243:49310:user49310:tXr2cCKHiY
    103.241.199.4:49222:user49222:wLkhVQgfdH
    103.162.31.78:49142:user49142:XEXimEnq4g
    103.162.31.78:49028:user49028:DpYoRrTbGZ
    103.162.31.78:49098:user49098:kGeQHMKYMV
    103.241.199.1:49462:user49462:sRcemgYifR
    103.241.199.6:49053:user49053:7JPH09Ghhz
    103.15.89.217:49373:user49373:z05AUpJEFV
    103.15.89.218:49194:user49194:1VCzDBddWL
    103.162.30.76:49126:user49126:inzFJggf8i
    103.241.199.8:49006:user49006:mI3Hfosdrb
    103.162.31.76:49068:user49068:4UaLYrA9tu
    103.121.90.199:49374:user49374:j9aKGr9spz
    103.162.31.78:49035:user49035:kAVIkXvKvW
    103.162.31.76:49095:user49095:GtzzAyPoHb
    103.241.199.16:49017:user49017:07qXRgWgGT
    103.241.199.2:49138:user49138:FJhpzFPyuJ
    103.241.199.15:49180:user49180:MmHr2xnxZ4
    103.79.143.230:49021:user49021:fzNnvkIajy
    103.162.31.77:49177:user49177:vIgFt2ZpDn
    103.241.199.20:49210:user49210:RsQlhhH1JT
    103.15.89.217:49416:user49416:uZ43SrLhj3
    103.162.31.72:49009:user49009:eAUxGW84Qa
    103.79.141.79:49139:user49139:aGMA5T0o0q
    103.162.30.78:49076:user49076:o5MxFhgsTG
    103.162.31.77:49162:user49162:8BbicU8R5S
    103.79.141.81:49002:user49002:h6Y2VJVOPi
    103.162.30.78:49027:user49027:5bacWQuogX
    103.162.31.14:49130:user49130:Begao6ZDXP
    103.241.199.17:49075:user49075:OaONjUiu48
    103.162.31.77:49137:user49137:42gJ1sbSAM
    103.162.31.11:49382:user49382:74NXDEahss
    103.162.31.72:49184:user49184:1HJFwtWvYr
    103.162.31.77:49028:user49028:8b5b1fLTZQ
    103.162.31.77:49081:user49081:24bELm3aDs
    103.241.199.15:49144:user49144:DFw7QDmMY8
    103.162.31.78:49195:user49195:LlSJLQTCua
    103.162.31.14:49118:user49118:TGNz7uH3hB
    103.79.143.230:49016:user49016:UEG69ebIPX
    103.162.31.14:49172:user49172:c5u2Zw6aXn
    103.79.141.139:49085:user49085:OtaxX9oteD
    103.162.31.11:49026:user49026:IgXtV78Hd2
    103.162.31.76:49079:user49079:xKtVQFfmqt
    103.15.89.242:49019:user49019:rndLanZkol
    103.162.31.72:49233:user49233:RVPSvS9Unx
    103.79.141.69:49166:user49166:EbfVSKKFCG
    103.241.199.19:49218:user49218:HOxiZYgeyS
    103.241.199.10:49343:user49343:LLIBrI99j8
    103.241.199.15:49404:user49404:9Fv2bUOJlm
    103.121.90.206:49013:user49013:xGsDwitaHo
    103.162.31.34:49416:user49416:PbIfIyE5qi
    103.162.31.72:49024:user49024:1oOoNntnoi
    103.79.143.230:49018:user49018:v13miBCHVF
    103.79.141.79:49094:user49094:gvjJVPvjYl
    103.121.90.181:49110:user49110:SnmmsclZAq
    103.121.90.206:49114:user49114:m7dhCgxyJH
    103.162.31.14:49155:user49155:C0ZT6NZj1g
    103.162.31.78:49031:user49031:1k4EkGwJK7
    103.3.246.12:49360:user49360:6tRmEiY4UE
    103.15.89.220:49369:user49369:95q8JHiFDg
    103.162.31.14:49093:user49093:QgUHY9zqBq
    103.162.31.78:49067:user49067:S1rCz9xk3j
    103.15.89.241:49118:user49118:YiOt7UFC1l
    103.121.90.181:49061:user49061:Ga0DCCNLHB
    103.162.31.77:49077:user49077:nn3YxzQnlo
    103.187.169.10:49161:user49161:cue7UOgQjE
    103.187.168.16:49061:user49061:FepyH1H7hq`
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_helpers/proxy.ts